export default "__VITE_ASSET__Dha9eEtl__"